module.exports = __webpack_public_path__ + "static/media/reemplazo-de-smartphones.7cb20968.png";